export type VideoPreviewWindowData = {
    title: string;
    videoId: string;
    autoplay?: boolean;
    closeOnEnded?: boolean;
    // Runs once when the user closes this video (not when another video replaces it).
    onClose?: () => void;
};

let activeVideo: VideoPreviewWindowData | null = null;
const listeners = new Set<() => void>();

const notify = () => listeners.forEach((listener) => listener());

export const openVideoPreviewWindow = (video: VideoPreviewWindowData) => {
    activeVideo = video;
    notify();
};

export const closeVideoPreviewWindow = () => {
    const onClose = activeVideo?.onClose;
    activeVideo = null;
    notify();
    onClose?.();
};

export const getActiveVideoPreviewWindow = () => activeVideo;

export const subscribeToVideoPreviewWindow = (listener: () => void) => {
    listeners.add(listener);
    return () => listeners.delete(listener);
};
